import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import '@/icons'
import 'element-ui/lib/theme-chalk/index.css';

import * as validate from './utils/validate'
import * as API from './api'

Vue.prototype.$validate = validate
Vue.prototype.$API = API

Vue.use(ElementUI);

Vue.config.productionTip = false

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default vue
